import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import Card from "components/card";

Chart.register(ArcElement, Tooltip, Legend);

const ReportDonutChart = ({ donutInfo }) => {
  const [chartsData, setChartsData] = useState([]);

  useEffect(() => {
    if (donutInfo) {
      // Map through each DonutChartData entry and prepare data for each chart
      const preparedCharts = donutInfo?.map((data) => {
        const { DonutChartDetails, plotData } = data;

        // Extract keys dynamically from DonutChartDetails (excluding timestamps)
        const labels = Object.keys(DonutChartDetails).filter(
          (key) => key !== "DonutChartName" && key !== "timestamps"
        );

        // Prepare dataset for the chart
        const datasets = labels.map((key, index) => ({
          label: DonutChartDetails[key],
          data: plotData[key],
          backgroundColor: getColor(index),
          borderWidth: 1,
        }));

        return {
          title: DonutChartDetails.DonutChartName,
          chartData: {
            labels: plotData.timestamps,
            datasets,
          },
        };
      });

      setChartsData(preparedCharts);
    }
  }, [donutInfo]);

  // Utility function to get colors for each dataset
  const getColor = (index) => {
    const colors = [
      "#42AACC",
      "#EE5D50",
      "#4299e1",
      "#A3AED0",
      "#D69E2E",
      "#809D3C",
      "#A35C7A",
    ];
    return colors[index % colors.length];
  };

  if (chartsData.length === 0) return <div>Loading...</div>;

  return (
    <div
      className="grid gap-5"
      style={{
        gridTemplateColumns: `repeat(${Math.min(
          chartsData.length,
          4
        )}, minmax(0, 1fr))`,
      }}
    >
      {chartsData.map((chart, index) => (
        <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
          <div className="flex flex-row justify-between px-3 pt-2">
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              {chart.title}
            </h4>
          </div>

          <div
            className="mb-auto flex h-[380px] w-full items-center justify-center"
            style={{
              maxHeight: "300px",
              maxWidth: "100%",
              marginTop: "20px",
            }}
          >
            <Doughnut
              data={chart.chartData}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                      color: "#000",
                      generateLabels: (chart) => {
                        const { datasets } = chart.data;
                        return datasets.map((dataset, i) => ({
                          text: dataset.label,
                          fillStyle: dataset.backgroundColor,
                        }));
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default React.memo(ReportDonutChart);
